var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.proxyUrl,"target":"_blank"}},[_c('v-lazy-image',{staticClass:"img",attrs:{"src":_vm.proxyUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }